"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _langLibrary = _interopRequireDefault(require("@deosite/helpers/langLibrary"));
var _Product = _interopRequireDefault(require("@deosite/ui-entities/Product"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _LinkRaw = _interopRequireDefault(require("@commerce-ui/core2/LinkRaw"));
var _Image = _interopRequireDefault(require("../Image"));
var _RouteContext = require("@deosite/lib/RouteContext");
var _usePriceWithCurrency = _interopRequireDefault(require("@deosite/api/hooks/common/usePriceWithCurrency"));
var _useCategoryTree2 = require("@deosite/api/hooks/common/useCategoryTree");
var _useAnalytics4AndCommerceTags = _interopRequireDefault(require("@deosite/api/hooks/common/useAnalytics4AndCommerceTags"));
var _percentDecrease = _interopRequireDefault(require("@deosite/helpers/percentDecrease"));
var _getPromoCategory = _interopRequireDefault(require("@deosite/helpers/getPromoCategory"));
var _getLowProductAvailability = _interopRequireDefault(require("@deosite/helpers/getLowProductAvailability"));
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/hooks/useAppConfiguration"));
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultProps = {
  otherDefaultImage: false,
  reducedMargins: false,
  showProductId: true,
  labelAdditionalStyles: {},
  labelPosition: {}
};
var ProductBox = function ProductBox(props) {
  var _product$availability, _product$category;
  var product = props.product,
    colors = props.colors,
    _props$otherDefaultIm = props.otherDefaultImage,
    otherDefaultImage = _props$otherDefaultIm === void 0 ? defaultProps.otherDefaultImage : _props$otherDefaultIm,
    roundness = props.roundness,
    _props$reducedMargins = props.reducedMargins,
    reducedMargins = _props$reducedMargins === void 0 ? defaultProps.reducedMargins : _props$reducedMargins,
    _props$showProductId = props.showProductId,
    showProductId = _props$showProductId === void 0 ? defaultProps.showProductId : _props$showProductId,
    _props$labelAdditiona = props.labelAdditionalStyles,
    labelAdditionalStyles = _props$labelAdditiona === void 0 ? defaultProps.labelAdditionalStyles : _props$labelAdditiona,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? defaultProps.labelPosition : _props$labelPosition,
    mainColor = props.mainColor,
    imageOverlayOpacity = props.imageOverlayOpacity,
    parentListType = props.parentListType,
    parentListIndex = props.parentListIndex;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var priceWithCurrency = (0, _usePriceWithCurrency["default"])();
  var price = product.price,
    image = product.image,
    name = product.name,
    collection = product.collection,
    promoLabelIndex = product.promoLabelIndex;
  var _useRouteContext = (0, _RouteContext.useRouteContext)(),
    Link = _useRouteContext.Link;
  var outOfStock = (0, _getLowProductAvailability["default"])((_product$availability = product.availability) === null || _product$availability === void 0 ? void 0 : _product$availability.level);
  var translations = {
    more: (0, _langLibrary["default"])("more"),
    "new": (0, _langLibrary["default"])("New arrival"),
    outOfStock: (0, _langLibrary["default"])("Out of stock"),
    productCode: (0, _langLibrary["default"])("product code"),
    hitOfWeek: (0, _langLibrary["default"])("Hit of the week"),
    hitOfMonth: (0, _langLibrary["default"])("Hit of the month"),
    outlet: (0, _langLibrary["default"])("Outlet"),
    black: (0, _langLibrary["default"])("Cyber week"),
    additionalPromoLabel: (0, _langLibrary["default"])("additional_promo_label")
  };
  var circleLabelStyles = _objectSpread({
    width: "35px",
    height: "35px",
    borderRadius: "50px",
    color: "white",
    font: "xxs_caps",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "36px",
    textAlign: "center"
  }, labelAdditionalStyles);
  var _useAnalyticsAndComme = (0, _useAnalytics4AndCommerceTags["default"])(),
    productClicked = _useAnalyticsAndComme.productClicked;
  var _useCategoryTree = (0, _useCategoryTree2.useCategoryTree)(),
    getCategoryNameForGivenCategoryId = _useCategoryTree.getCategoryNameForGivenCategoryId;
  var promoLabels = [translations.hitOfWeek, translations.hitOfMonth, translations["new"], translations.outlet, translations.black];
  var currentProductGotAdditionalLabel = (0, _getPromoCategory["default"])({
    language: language,
    ids: product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids
  });
  var blackNovemberId = 4;
  return __jsx(_Box["default"], {
    "data-test": "product-box",
    sx: {
      width: "100%",
      position: "relative"
    }
  }, __jsx(Link, {
    route: "product-page",
    params: product
  }, __jsx(_LinkRaw["default"], {
    title: product.name,
    onClick: function onClick() {
      return productClicked(product, getCategoryNameForGivenCategoryId(product.category.id), parentListType, parentListIndex);
    }
  }, image && __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Image["default"], {
    overlay: true,
    overlayOpacity: imageOverlayOpacity,
    roundness: roundness,
    sx: {
      aspectRatio: 1,
      objectFit: "contain",
      mb: "s5"
    },
    image: otherDefaultImage ? otherDefaultImage.originalSrc ? otherDefaultImage : image : image,
    sizes: "(max-width: 460px) and (min-width: 10px) 210px, 420px",
    cloudflareEnabled: global.__appConfig__.smallImageCloudflareEnabled,
    quality: global.__appConfig__.smallImageQuality
  })), __jsx(_Box["default"], {
    as: "p",
    sx: {
      width: "100%",
      color: "neutral700",
      font: "xs",
      my: reducedMargins ? 0 : "s3",
      display: "flex",
      justifyContent: collection.name ? "space-between" : "flex-end",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "1",
      overflow: "hidden"
    }
  }, collection.name && __jsx(_Box["default"], {
    as: "span"
  }, collection.name), product.sku && showProductId && __jsx(_Box["default"], {
    as: "span",
    sx: {
      textTransform: "uppercase"
    }
  }, translations.productCode, " ", product.sku)), __jsx(_Box["default"], {
    sx: {
      width: "100%"
    }
  }, __jsx(_Box["default"], {
    as: "p",
    sx: {
      width: "100%",
      font: "s_sans",
      color: outOfStock ? "beigeDarken" : mainColor !== null && mainColor !== void 0 ? mainColor : "main",
      pt: "s3",
      maxHeight: "70px",
      overflow: "hidden",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      WebkitLineClamp: "3",
      mb: "s6"
    }
  }, promoLabelIndex !== undefined && promoLabelIndex !== blackNovemberId && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "positive",
      display: "block"
    }
  }, promoLabels[promoLabelIndex]), promoLabelIndex === blackNovemberId && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "white",
      display: "block",
      backgroundColor: "black",
      width: 122,
      textAlign: "center",
      paddingTop: 2,
      paddingX: 4
    }
  }, promoLabels[promoLabelIndex]), currentProductGotAdditionalLabel && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "negative",
      display: "block"
    }
  }, translations.additionalPromoLabel), outOfStock && __jsx(_Box["default"], {
    as: "span",
    sx: {
      color: "neutral900",
      display: "block"
    }
  }, translations.outOfStock), name)), __jsx(_Box["default"], {
    sx: {
      font: "".concat(price.special ? "base_sans_regular_discount" : "base_sans_bold"),
      color: outOfStock ? "beigeDarken" : mainColor !== null && mainColor !== void 0 ? mainColor : "main"
    }
  }, priceWithCurrency(price.regular)), price.special && __jsx(_Box["default"], null, __jsx(_Box["default"], {
    sx: {
      color: outOfStock ? "beigeDarken" : "negative",
      font: "base_sans_bold"
    }
  }, priceWithCurrency(price.special))), price.special && __jsx(_Box["default"], {
    sx: _objectSpread({
      position: "absolute",
      top: "0",
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      p: "s5"
    }, labelPosition)
  }, __jsx(_Box["default"], {
    as: "span",
    sx: _objectSpread(_objectSpread({}, circleLabelStyles), {}, {
      bg: outOfStock ? "beigeDarken" : "negative"
    })
  }, "-", (0, _percentDecrease["default"])(product.price.regular, product.price.special), "%")))), colors && __jsx(_Box["default"], {
    sx: {
      font: "xs",
      color: "neutral700",
      mt: "s7",
      display: "flex",
      alignItems: "center",
      flexDirection: "row"
    }
  }, colors.slice(0, 5).map(function (color, index) {
    return __jsx(_Box["default"], {
      sx: {
        bg: color,
        width: "16px",
        height: "16px",
        mr: "s3",
        border: "0px"
      },
      key: index
    });
  }), colors.length > 5 && __jsx(_Box["default"], {
    as: "span"
  }, "+", colors.length - 5, " ", translations.more)));
};
var _default = ProductBox;
exports["default"] = _default;